export const PDF_PAGE_WIDTH = 612;
export const PDF_PAGE_HEIGHT = 792;

export const normalizeClickToPdfCoords = ({ clientX, clientY, rect }) => {
  const x = clientX - rect.left;
  const y = clientY - rect.top;

  return {
    x: (x / rect.width) * PDF_PAGE_WIDTH,
    y: (y / rect.height) * PDF_PAGE_HEIGHT,
  };
};

export const pdfCoordsToPixels = ({ x, y, width, height }) => ({
  x: (x / PDF_PAGE_WIDTH) * width,
  y: (y / PDF_PAGE_HEIGHT) * height,
});
